export default __webpack_public_path__ + "static/media/produk 5.3fa74b78.png";